import { render, staticRenderFns } from "./ProductsListWidget.vue?vue&type=template&id=48e818c6&scoped=true"
import script from "./ProductsListWidget.vue?vue&type=script&lang=js"
export * from "./ProductsListWidget.vue?vue&type=script&lang=js"
import style0 from "./ProductsListWidget.vue?vue&type=style&index=0&id=48e818c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e818c6",
  null
  
)

export default component.exports